import { Directive, ElementRef, HostListener, Input, Renderer2, AfterViewInit } from '@angular/core';

@Directive({ selector: '[appSubmenuPosition]' })
export class SubmenuPositionDirective implements AfterViewInit {
  @Input() submenu!: HTMLElement;

  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {}

  ngAfterViewInit() {
    if (this.submenu) {
      this.renderer.setStyle(this.submenu, 'position', 'absolute');
      this.renderer.setStyle(this.submenu, 'visibility', 'hidden');
      this.renderer.setStyle(this.submenu, 'opacity', '0');
    }
  }

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: MouseEvent) {
    this.toggleSubmenu(event, true);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.toggleSubmenu(undefined, true);
  }

  private toggleSubmenu(event?: MouseEvent, state = false) {
    if (!this.submenu) {
      return;
    }
    if (state && event) {
      const submenuElement = this.submenu;
      const menuItemElement = this.el.nativeElement;
      const menuOffset = 15;
      if (submenuElement && menuItemElement) {
        const menuItemRect = menuItemElement.getBoundingClientRect();
        const submenuHeight = submenuElement.offsetHeight;
        const windowHeight = window.innerHeight;
        if (menuItemRect.bottom + submenuHeight > windowHeight) {
          const remainingSpace = windowHeight - menuItemRect.bottom;
          const topPosition = remainingSpace + (menuItemRect.height - submenuHeight - menuOffset);
          this.renderer.setStyle(submenuElement, 'top', `${topPosition}px`);
        }

        const submenuWidth = submenuElement.offsetWidth;
        const windowWidth = window.innerWidth;
        if (menuItemRect.right + submenuWidth > windowWidth) {
          this.renderer.setStyle(submenuElement, 'left', `${-submenuWidth}px`);
        }
        this.renderer.setStyle(submenuElement, 'visibility', 'visible');
        this.renderer.setStyle(submenuElement, 'opacity', '1');
      }
    } else {
      this.renderer.setStyle(this.submenu, 'visibility', 'hidden');
      this.renderer.setStyle(this.submenu, 'opacity', '0');
    }
  }
}